import { createHashHistory } from 'history'
import { takeEvery, call, put } from 'redux-saga/effects'
import loginApi from '@api/login'
import { success } from '../../actions/common'
import { REQUEST_OUT } from './../../actions/common'

const history = createHashHistory()

function logOutApi({ payload }) {
    return loginApi.logout(payload).then(res => {
        if (res.status == 0) {
            return res.data
        }
    })

}

function* takeOut(payload) {
    const data = yield call(logOutApi, payload)
    if (data) {
        sessionStorage.removeItem("userInfo");
        sessionStorage.removeItem("token");
        history.replace("/login");
    }
}

export default function* Index() {
    // action REQUEST_OUT触发后执行takeOut事件
    yield takeEvery(REQUEST_OUT, takeOut);
}
